import Vue from "vue";
import VueRouter from "vue-router";
import vuex from "../store";
import { saveLandingParams } from "../utils/landingParamUtil";

Vue.use(VueRouter);

const routes = [
  {
    path: "/registration",
    name: "WelcomeRegister",
    props: true,
    component: () => import("@/views/Welcome.vue"),
    meta: {
      layout: "AppLayoutWelcome",
      protected: false,
      action: "registration",
    },
  },
  {
    path: "/login",
    alias: "/",
    props: true,
    component: () => import("@/views/Welcome.vue"),
    meta: {
      layout: "AppLayoutWelcome",
      protected: false,
      action: "login",
    },
  },
  {
    path: "/registration/email",
    name: "EmailRegistration",
    props: true,
    component: () => import("@/views/Registration.vue"),
    meta: {
      layout: "AppLayoutRegisterLogin",
      protected: false,
      mode: "email",
    },
  },
  {
    path: "/registration/phone",
    name: "PhoneRegistration",
    props: true,
    component: () => import("@/views/Registration.vue"),
    meta: {
      layout: "AppLayoutRegisterLogin",
      protected: false,
      mode: "phone",
    },
  },
  {
    path: "/registration/second-factor",
    name: "RegistrationSecondFactor",
    props: true,
    component: () => import("@/views/RegistrationSecondFactor.vue"),
    meta: {
      layout: "AppLayoutRegisterLogin",
      protected: false,
    },
  },
  {
    path: "/login/second-factor",
    name: "LoginSecondFactor",
    props: true,
    component: () => import("@/views/LoginSecondFactor.vue"),
    meta: {
      layout: "AppLayoutRegisterLogin",
      protected: false,
    },
  },
  {
    path: "/login/email",
    name: "EmailLogin",
    props: true,
    component: () => import("@/views/Login.vue"),
    meta: {
      layout: "AppLayoutRegisterLogin",
      protected: false,
      mode: "email",
    },
  },
  {
    path: "/emailConfirmation",
    name: "EmailConfirmation",
    props: true,
    component: () => import("@/views/EmailConfirmation.vue"),
    meta: {
      layout: "AppLayoutRegisterLogin",
      protected: false,
    },
  },
  {
    path: "/login/phone/:userId?",
    name: "PhoneLogin",
    props: true,
    component: () => import("@/views/Login.vue"),
    meta: {
      layout: "AppLayoutRegisterLogin",
      protected: false,
      mode: "phone",
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("@/views/ForgotPassword.vue"),
    meta: {
      layout: "AppLayoutRegisterLogin",
      protected: false,
    },
  },
  {
    path: "/leasing/login",
    name: "LeasingLogin",
    props: true,
    component: () => import("@/views/Login.vue"),
    meta: {
      layout: "AppLayoutRegisterLogin",
      protected: false,
      mode: "phone",
    },
  },
  {
    path: "/leasing/login/second-factor",
    name: "LeasingLoginSecondFactor",
    props: true,
    component: () => import("@/views/LoginSecondFactor.vue"),
    meta: {
      layout: "AppLayoutRegisterLogin",
      protected: false,
    },
  },
  {
    path: "/leasing/prescore",
    name: "LeasingPrescore",
    component: () => import("@/views/LeasingPrescore.vue"),
    meta: {
      layout: "AppLayoutPreliminaryAssessment",
      protected: true,
    },
  },
  {
    path: "/leasing/profile",
    name: "LeasingProfile",
    props: true,
    component: () => import("@/views/LeasingProfile.vue"),
    meta: {
      protected: false,
    },
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: () => import("@/views/Onboarding.vue"),
    meta: {
      layout: "AppLayoutOnboarding",
      protected: true,
    },
  },
  {
    path: "/preliminary-assessment",
    name: "PreliminaryAssessment",
    component: () => import("@/views/PreliminaryAssessment.vue"),
    meta: {
      layout: "AppLayoutPreliminaryAssessment",
      protected: true,
    },
  },
  {
    path: "/offers",
    name: "Offers",
    component: () => import("@/views/Offers.vue"),
    meta: {
      protected: true,
    },
  },
  {
    path: "/user/profile",
    alias: "/",
    name: "UserProfile",
    component: () => import("@/views/UserProfile.vue"),
    meta: {
      layout: "AppLayoutUser",
      protected: true,
    },
  },
  {
    path: "/user/todos",
    name: "UserTodos",
    component: () => import("@/views/UserTodos.vue"),
    meta: {
      layout: "AppLayoutUser",
      protected: true,
    },
  },
  {
    path: "/user/submit-missing-documents/:id",
    props: true,
    name: "UserSubmitMissingDocuments",
    component: () => import("@/views/UserSubmitMissingDocuments.vue"),
    meta: {
      layout: "AppLayoutUser",
      protected: true,
    },
  },
  {
    path: "/user/applications",
    name: "UserApplications",
    component: () => import("@/views/UserApplications.vue"),
    meta: {
      layout: "AppLayoutUser",
      protected: true,
    },
  },
  {
    path: "/store/:storeId",
    props: true,
    name: "Store",
    component: () => import("@/views/Store.vue"),
    meta: {
      layout: "AppLayoutUser",
      protected: true,
    },
  },
  {
    path: "/stores",
    name: "Stores",
    component: () => import("@/views/Stores.vue"),
    meta: {
      layout: "AppLayoutUser",
      protected: true,
    },
  },
  {
    path: "/user/purchase-history",
    name: "UserPurchaseHistory",
    component: () => import("@/views/UserPurchaseHistory.vue"),
    meta: {
      layout: "AppLayoutUser",
      protected: true,
    },
  },
  {
    path: "/user/purchase/:purchaseId",
    props: true,
    name: "Purchase",
    component: () => import("@/views/Purchase.vue"),
    meta: {
      layout: "AppLayoutUser",
      protected: true,
    },
  },
  {
    path: "/application",
    name: "LoanApplication",
    props: true,
    component: () => import("@/views/LoanApplicationFlow.vue"),
    meta: {
      layout: "AppLayoutLoanApplication",
      protected: true,
    },
  },
  {
    path: "/checkout/:purchaseId",
    name: "Checkout",
    props: true,
    component: () => import("@/views/Checkout.vue"),
    meta: {
      layout: "AppLayoutCheckout",
      protected: false,
    },
  },
  {
    path: "/leasing/:dealerId?/:publicId?",
    name: "Leasing",
    props: true,
    component: () => import("@/views/Leasing.vue"),
    meta: {
      protected: false,
    },
  },
  {
    path: "*",
    name: "WelcomeLogin",
    props: true,
    component: () => import("@/views/Welcome.vue"),
    meta: {
      layout: "AppLayoutWelcome",
      protected: false,
      action: "login",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  const isLeasingPath = /^\/leasing.*/i.test(to.path);

  let isLoggedIn = vuex.getters["session/isReady"];
  let getBackPath = vuex.getters["profile/getBackPath"];

  if (!isLeasingPath) {
    if (
      !isLoggedIn &&
      (to.path === "/" || to.path === "/registration" || to.path === "/login")
    ) {
      saveLandingParams(to.query);
    }

    if (!to.meta.protected) {
      if (
        !isLoggedIn ||
        to.name === "EmailConfirmation" ||
        to.name === "Checkout"
      ) {
        next();
      } else {
        next({ path: "/user/profile" });
      }
    } else {
      if (isLoggedIn) {
        next();
      } else {
        next({ path: "/login" });
      }
    }
  } else {
    let { dealerId, publicId } = to.params;

    if (dealerId && publicId) {
      if (isLoggedIn) {
        vuex.dispatch("session/logout");
        next({ path: "/leasing/login" });
      }

      localStorage.setItem(
        "leasing-landing-params",
        JSON.stringify({ dealerId, publicId })
      );
    } else {
      try {
        let { dealerId: savedDealerId, publicId: savedpublicId } = JSON.parse(
          localStorage.getItem("leasing-landing-params")
        );
        dealerId = savedDealerId;
        publicId = savedpublicId;
      } catch {}
    }
    vuex.dispatch("leasing/saveLandingParams", { dealerId, publicId });

    if (isLoggedIn) {
      if (to.path === "/leasing") {
        next({ path: getBackPath });
      }
      next();
    } else {
      if (
        !["Leasing", "LeasingLogin", "LeasingLoginSecondFactor"].includes(
          to.name
        )
      ) {
        next({ name: "LeasingLogin" });
      } else {
        if (to.name === "LeasingLogin") {
          if (!dealerId || !publicId) {
            next({ name: "Leasing" });
          }
          next();
        } else if (to.name === "Leasing") {
          if (dealerId && publicId) {
            next({ name: "LeasingLogin" });
          }
          next();
        } else if (to.name === "LeasingLoginSecondFactor") {
          if (!dealerId || !publicId) {
            next({ name: "Leasing" });
          }
          next();
        }
      }
    }
  }
});

export default router;
